var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M14.905 16.44a9.07 9.07 0 01-5.864 2.133c-4.993 0-9.041-4-9.041-8.933C0 4.706 4.048.707 9.04.707a9.07 9.07 0 015.865 2.134A9.07 9.07 0 0120.77.707c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 01-5.865-2.134z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M14.905 16.44a8.87 8.87 0 003.177-6.8 8.87 8.87 0 00-3.177-6.8A9.07 9.07 0 0120.77.708c4.993 0 9.04 4 9.04 8.933 0 4.934-4.047 8.933-9.04 8.933a9.07 9.07 0 01-5.865-2.134z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M14.905 16.44a8.87 8.87 0 003.177-6.8 8.87 8.87 0 00-3.177-6.8 8.87 8.87 0 00-3.176 6.8 8.87 8.87 0 003.176 6.8z",
    clipRule: "evenodd"
  })));
}

export default SvgLogoMastercard;